export default __webpack_public_path__ + "static/media/logo_RTE.bfbb13f9.png";